module.exports = __webpack_public_path__ + "static/img/cw_logomark_bk.82ab0f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/cw_logomark_bk.png
// module id = 0MUS
// module chunks = 0